// A per-submission idempotency key the backend dedups on, so a retried
// order/cash-payment request (network blip today, offline outbox later) never
// double-inserts or double-charges. Uses crypto.randomUUID where available with a
// plain fallback for older browsers.
export const newClientRequestId = () =>
  (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function')
    ? crypto.randomUUID()
    : `cr_${Date.now()}_${Math.random().toString(36).slice(2, 10)}`;
